/* eslint-disable consistent-return */
/* eslint-disable implicit-arrow-linebreak */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContextMenuTrigger } from 'react-contextmenu';
import uniqueid from 'lodash.uniqueid';
import sh from 'components/shared.module.css';
import FacetsContextMenu from './FacetsContextMenu';
import actions from '../../../actions';
import FacetModal from '../../Modals/FacetModal/FacetModal';
// import circular from '../../../images_tmp/circular.gif';
// import compressed from '../../../images_tmp/compressed.gif';
import s from './facets.module.css';


// <DropDownFacet title='Facet Type title 1' items={2} setValued hasImages>
// <FacetItem title='facet subtype Item 1' items={1} img={circular} />

const { requestAllFacets } = actions;

const template = {

  genFacetSubTypes: (allSubTypes, facetId, datasetId) => {
    const datasetFacetsObj = allSubTypes[datasetId];
    const subTypes = datasetFacetsObj[facetId];
    if (subTypes) {
      return Object.keys(subTypes).map((key) => {
        if (subTypes[key] && (subTypes[key].typeId === facetId)) {
          const { id, title, items, img } = subTypes[key]; // typeId exist in subTypes[key]
          return (
            <FacetItem key={id} {...{ title }} {...{ items }} {...{ img }} />
          );
        }
        return '';
      });
    }
    return '';
  },

  genFacets: (facets, datasetId) => {
    const { allTypes, allSubTypes } = facets;
    if (!allTypes || !allSubTypes) { return; }
    const datasetFacetsObj = allTypes[datasetId];
    if (!datasetFacetsObj) { return; }
    const facetKeys = Object.keys(datasetFacetsObj);
    return facetKeys.map((fkey) => {
      const facetObj = datasetFacetsObj[fkey];
      const { id, title, items, setValued, hasImages } = facetObj;
      return (
        <DropDownFacet key={id} {...{ title }} {...{ items }} {...{ setValued }} {...{ hasImages }} collapsed={(title === 'with images')}>
          {template.genFacetSubTypes(allSubTypes, id, datasetId)}
        </DropDownFacet>
      );
    });
  },

};

// TODO add spinner for facets
const DropDownFacet = ({ title, children, collapsed, items, setValued, hasImages, openContextMenu, closeContextMenu }) => {
  const [isCollapsed, toggleCollapse] = useState(collapsed);
  const [isSelected, toggleSelection] = useState(false);
  // const [contextMenuIsOpen, setContextMenuState] = useState(false); // TODO
  const icon = isCollapsed ? s.facetsIconMinus : s.facetsIconPlus;
  const menuId = uniqueid(title.replace(/\s+/g, '')); // title should be unique
  return (
    <>
      {/* <div className='d-flex justify-content-center align-content-around flex-wrap'> */}
      <ContextMenuTrigger id={menuId} holdToDisplay={1000}>
        <div className={`d-flex ml-3 ml-sm-1 ${s.facetCont}`}>
          <div className={icon} onClick={() => toggleCollapse(!isCollapsed)} />
          <div className={`${s.titleCont} ${(isSelected) ? s.titleContSel : ''}`} onClick={() => toggleSelection(!isSelected)}>
            {(isSelected) ? <FontAwesomeIcon icon={['far', 'check-square']} className={s.checkIcon} /> : ''}
            <div className={`${s.title} ${(isSelected) ? sh.titleSelected : ''}`}>
              <span>{title}</span>
              <span className={s.matchNumber}>{`${items}`}</span>
            </div>
            {((setValued) || (hasImages)) && (
              <div className='icCont'>
                <div className={s.fixPos}>
                  {(setValued) ? <FontAwesomeIcon icon={['far', 'clone']} className={s.checkIcon} /> : ''}
                  {(hasImages) ? <FontAwesomeIcon icon={['fas', 'images']} className={s.checkIcon} /> : ''}
                </div>
              </div>
            )}
          </div>
        </div>
      </ContextMenuTrigger>
      {/* </div> */}
      <FacetsContextMenu {...{ menuId }} />
      <Collapse in={isCollapsed}>
        <div>
          <div className='ml-4 ml-sm-2'>
            <div className='d-flex justify-content-start align-content-around flex-wrap w-100'>
              {children}
            </div>
          </div>
        </div>
      </Collapse>
    </>
  );
};

const FacetItem = ({ title, items, img }) => {
  const [isSelected, toggleSelection] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const closeModal = () => setModalIsOpen(false);
  const openModal = () => setModalIsOpen(true);

  // TODO img title
  return (
    <div className={`d-inline ml-2 ${s.facetCont}`}>
      <div className={`d-flex ${s.facetTitleCont}`}>
        <div className={s.facetsIconItem} />
        <div className={`${s.titleContItem} ${(isSelected) ? s.titleContSel : ''}`} onClick={() => toggleSelection(!isSelected)}>
          {(isSelected) ? <FontAwesomeIcon icon={['far', 'check-square']} className={s.checkIcon} /> : ''}
          <div className={`${s.title} ${(isSelected) ? sh.titleSelected : ''}`}>
            <span>{title}</span>
            <span className={s.matchNumber}>{`${items}`}</span>
          </div>
        </div>
      </div>
      {(img)
        ? (
          <div className={`d-flex ${s.facetImgCont} ${(isSelected) ? s.facetImgContSelected : ''}`}>
            <img src={img} alt='todo-alt-text' onClick={() => toggleSelection(!isSelected)} className={s.facetItemimg} />
            <FontAwesomeIcon icon={['fas', 'search-plus']} size='lg' className={s.zoomIcon} onClick={() => openModal()} />
          </div>
        )
        : ''}
      <FacetModal title='todo title' {...{ img }} show={modalIsOpen} onHide={closeModal} />
    </div>
  );
};

const Facets = ({ tabs, location }) => {
  const dispatch = useDispatch();
  const { facets } = useSelector(state => ({
    facets: state.facets
  }));

  useEffect(
    () => {
      if ((!facets.allTypes) || (!facets.allSubTypes)) dispatch(requestAllFacets());
    }, [dispatch, facets]
  );

  const { dataset } = tabs[location.pathname.substr(9)];
  const facetsEntries = template.genFacets(facets, dataset.id);

  return (
    <div className={sh.normalize}>
      <div className={sh.headerCategory}><span className='ml-1'>Facets</span></div>
      <div className={sh.fixSidePanelScrollbar}>
        {facetsEntries}
        {/* <div style={{ padding: '5px 20px', background: 'red', color: 'black', fontWeight: 'bold', opacity: 0.8 }}>temp mock data below:</div> */}
        <DropDownFacet title='Nested of Nested' items={2} setValue>
          <FacetItem title='facet subtype Item 1' items={1} />
          <FacetItem title='facet Item 2' items={21} />
          {/* a new class with width: calc(100% - 20px) should be
            added to any childs of childs  */}
          <DropDownFacet title='Facet Type title 1' items={2} setValue>
            <FacetItem title='facet subtype Item 1' items={1} />
            <FacetItem title='facet Item 2' items={21} />
            <DropDownFacet title='Facet Type title 1' items={2} setValue>
              <FacetItem title='facet subtype Item 1' items={1} />
              <FacetItem title='facet Item 2' items={21} />
            </DropDownFacet>
          </DropDownFacet>
        </DropDownFacet>
      </div>
    </div>
  );
};

export default Facets;
